import { useCallback } from 'react';

/**
 * Хук для форматування дат
 * Підтримує різні формати виводу дати
 */
const useFormatDate = () => {
    /**
     * Форматує дату у відносний формат (Сьогодні, Вчора, тощо)
     * @param {string|Date} dateString - Дата для форматування
     * @returns {string} - Відформатована дата
     */
    const formatRelativeDate = useCallback((dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        
        // Скидаємо час до початку дня для точного порівняння днів
        const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const nowOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
        const diffTime = nowOnly - dateOnly;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays === 0) {
            return "Сьогодні";
        } else if (diffDays === 1) {
            return "Вчора";
        } else if (diffDays === 2) {
            return "Позавчора";
        } else if (diffDays < 7) {
            return `${diffDays} днів тому`;
        } else {
            return date.toLocaleDateString('uk-UA');
        }
    }, []);

    /**
     * Форматує дату у повний формат з часом
     * @param {string|Date} dateString - Дата для форматування
     * @returns {string} - Відформатована дата з часом
     */
    const formatDateTime = useCallback((dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('uk-UA', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }, []);

    /**
     * Форматує дату у короткий формат (лише дата)
     * @param {string|Date} dateString - Дата для форматування
     * @returns {string} - Відформатована дата
     */
    const formatDate = useCallback((dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('uk-UA', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }, []);

    return {
        formatRelativeDate,
        formatDateTime,
        formatDate
    };
};

export default useFormatDate;
